// Promoção de "% de Desconto" no mesmo formato do Valor Fixo (pedido do dono,
// 27/10/2026): "De R$ 5,00 com [ 20 ]% de desconto = R$ 4,00", já com a conta
// feita. Aqui o número é a porcentagem como se fala (20 = 20%), aceita vírgula
// (12,5%); `value` é texto "12.5" (o formato que a promoção guarda).
const reais = (n) => `R$ ${Number(n || 0).toFixed(2).replace(".", ",")}`;

export default function DescontoPct({ base, value, onChange, compacto = false }) {
  const pct = Number(value);
  const temBase = Number(base) > 0;
  const temPct = Number.isFinite(pct) && pct > 0;
  const demais = temPct && pct >= 100;
  const final = temBase && temPct && !demais ? Math.round(Number(base) * (1 - pct / 100) * 100) / 100 : null;
  return (
    <div className="flex flex-col gap-1 min-w-0">
      <div className="flex items-center gap-1.5 flex-wrap text-xs">
        <span className="text-muted-foreground whitespace-nowrap">
          De <span className="line-through tabular-nums">{temBase ? reais(base) : "—"}</span> com
        </span>
        <div className="relative w-20">
          <input type="text" inputMode="decimal" value={value ? String(value).replace(".", ",") : ""}
            onChange={(e) => onChange(e.target.value)} placeholder="0" data-e2e="promo-pct"
            className={`w-full h-8 pl-2 pr-6 rounded-md border bg-background text-sm font-bold text-right tabular-nums focus:outline-none focus:ring-2 focus:ring-green-500/50 ${demais ? "border-red-500 text-red-600" : "text-blue-600 dark:text-blue-400"}`} />
          <span className="absolute right-2 top-1/2 -translate-y-1/2 text-xs font-bold text-muted-foreground pointer-events-none">%</span>
        </div>
        <span className="text-muted-foreground whitespace-nowrap">de desconto</span>
        {final != null && (
          <span className="font-bold text-green-600 dark:text-green-400 tabular-nums whitespace-nowrap">= {reais(final)}</span>
        )}
      </div>
      {demais ? (
        <p className="text-[10px] text-red-600 dark:text-red-400 font-medium">O desconto precisa ser menor que 100%</p>
      ) : !compacto && (
        <p className="text-[10px] text-muted-foreground">
          {final != null
            ? <>Preço que o cliente paga · economiza <strong className="text-green-600 dark:text-green-400">{reais(Number(base) - final)}</strong></>
            : "Digite quantos % de desconto o produto vai ter"}
        </p>
      )}
    </div>
  );
}
